import React from 'react';

import UpdatesTable from './../components/UpdatesTable';


const InboxUpdatesPage = () => {
    return (
        <div>
            <UpdatesTable />
        </div>
    );
};

export default InboxUpdatesPage;


// WEBPACK FOOTER //
// ./src/pages/InboxUpdatesPage.js